import React, { Component } from 'react';
import Navegacao from '../components/Navegacao.js';
import central from '../api/Central';
import { Link } from 'react-router-dom'
import Alert from '../components/Alert.js';
import { Formik, Field, Form } from 'formik';

class ChamadoNovo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            chamados: { rows: [] },
            disabled: false,
            erro: null,
            carregando: true,
            contas: { rows: [] },
            postado: false,
            values: { conta: 0}
        }
    }
    componentDidMount() {
        this.carrega();
    }
    carrega() {
        central.listaContas((resultado) => {
            this.setState({ contas: resultado , values: { conta: resultado.rows[0].idconta}});
        },
            (msgErro) => {
                this.setState({ erro: msgErro });
            },
            () => {
                this.setState({ carregando: false });
            }
        );
    }

    submit(values, actions) {
        alert(JSON.stringify(values));
        actions.setSubmitting(true);
        this.setState({ carregando: true });
        central.requestAndCatch("POST", "/chamados", JSON.stringify(values),
            (ret) => {
                this.setState({ postado: true });
            },
            (erro) => {
                this.setState({ erro: "Erro ao abrir chamado: " + erro });
            },
            () => {
                this.setState({ carregando: false });
                actions.setSubmitting(false);
            },
        );
    }
    render() {
        var formulario = <Formik
            onSubmit={(values, actions) => {
                this.submit(values, actions)
            }}
            initialValues={this.state.values}
            render={({ errors, status, touched, setFieldTouched, setFieldValue, isSubmiting, handleSubmit, handleChange }) => (
                <form onSubmit={handleSubmit}>
                    <fieldset>
                        <label htmlFor="conta">Contrato</label>
                        <Field component="select" name="conta" id="conta" placeholder="Selecione o contrato para abrir chamado">
                            {this.state.contas.rows.map((row => {
                                return <option key={row.idconta} value={row.idconta}>SERVIÇO {row.idconta} ({row.inst_logradouro}) - Vencimento dia {row.diavencimento}</option>;
                            }))}

                        </Field>
                        <label htmlFor="queixa">Digite sua queixa:</label>
                        <Field type="text" id="queixa" name="queixa" />
                        <label htmlFor="mensagem">Mensagem (opcional):</label>
                        <Field component="textarea" id="mensagem" name="mensagem" placeholder="Digite aqui uma mensagem para nossa equipe (opcional)" />
                        <button class="button-primary" type="submit">Abrir chamado</button>
                    </fieldset>
                </form>
            )}
        />;

        var loader = <Alert type="info">Aguarde...</Alert>;

        var errormsg = <Alert type="error">{this.state.erro}</Alert>;

        var obrigado = <Alert type="success">Chamado aberto com sucesso. <Link className="button" to="/chamados">Clique aqui para voltar</Link></Alert>;

        var componente;

        if (this.state.erro) {
            componente = errormsg;
        } else if (this.state.carregando) {
            componente = loader;
        } else if (this.state.postado) {
            componente = obrigado;
        } else {
            componente = formulario;
        }

        return (
            <section className="container">
                <Navegacao link="/chamados" titulo="Novo Chamado" />
                <section>
                    {componente}
                </section>
            </section>

        );

    }
}

export default ChamadoNovo;